import React, { useEffect } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { checkProStatus } from '../services/stripe';

export const PaymentSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const verifyPayment = async () => {
      if (user) {
        try {
          const isPro = await checkProStatus();
          if (!isPro) {
            // Wait a bit and try again, as the webhook might need time
            setTimeout(async () => {
              const retryPro = await checkProStatus();
              if (!retryPro) {
                console.error('Pro status not updated');
              }
            }, 5000);
          }
        } catch (error) {
          console.error('Error verifying payment:', error);
        }
      }
    };

    verifyPayment();
  }, [user]);

  const handleContinue = () => {
    navigate('/app');
  };

  if (!user) {
    navigate('/');
    return null;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: 'center',
            p: 4,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          <CheckCircleIcon
            sx={{ fontSize: 64, color: 'success.main', mb: 2 }}
          />
          <Typography variant="h4" gutterBottom>
            Welcome to Mailzen Pro!
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Thank you for your purchase. Your account has been upgraded to Pro status.
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            You now have access to all premium features including advanced email clients,
            custom device sizes, and template management.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleContinue}
            sx={{ mt: 2 }}
          >
            Continue to Dashboard
          </Button>
        </Box>
      </Container>
    </Box>
  );
}; 